/** Dev-only counters for background poll tuning (window.__b2bPollMetrics). */

type PollCounts = Record<string, number>;

const counts: PollCounts = Object.create(null);

const enabled = (): boolean => process.env.NODE_ENV !== 'production';

export const recordBackgroundPoll = (endpointKey: string) => {
    if (!enabled()) {
        return;
    }
    counts[endpointKey] = (counts[endpointKey] || 0) + 1;
    const w = window as Window & { __b2bPollMetrics?: PollCounts };
    w.__b2bPollMetrics = { ...counts };
};

export const getBackgroundPollMetrics = (): PollCounts => ({ ...counts });
